<template>
    <div>
        <div class="row card-body">
            <div class="col-md-12" v-if="canSignWithoutPinCode">
                <p>{{ $t("res_Label_SignDocumentConfirmation") }}</p>
            </div>
            <div class="mb-3-rem" v-if="this.isSignAndSend == false && this.isDelegatedDocumentSignProp == true">
                <label class="mb-2">{{ $t("res_Label_OnBehalfOf") }}</label>
                <v-checkbox v-model="onBehalfOf" color="#00ae8d" class="mt-0"></v-checkbox>
            </div> 
            <div class="col-md-12" v-if="this.isSignAndSend == true ? false : canSignWithoutPinCode == true ? false : true">
                <label class="mb-2">{{$t("res_Label_PinValue")}}</label>
                <v-text-field v-model="pinValue" label="" solo type="password" :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showNew ? 'text' : 'password'" 
                    @click:append="showNew = !showNew"></v-text-field>
            </div>

            <label class="mb-10" v-if="this.isSignAndSend == true">{{ $t("res_Label_SignDocumentConfirmation") }}</label>
            <!-- <div class="col-md-12" v-if="this.enableUserMultipleSignatures == true">
                <v-label>{{ $t("res_Label_Signature") }}</v-label> 
                <v-select :disabled="userSignatures == null || userSignatures.length <= 1" v-model="userSignature" :items="userSignatures" item-text="text" item-value="id" label="" solo return-object></v-select>  
                
            </div> -->

            <div v-if="showSignaturesList == true && enableUserToSelectSigner == true" style="">
                <v-label>{{ $t("res_Label_SelectSigner") }}</v-label> 
                <v-select
                    :disabled="signerList == null || signerList.length <= 1"
                    v-model="selectedSigner"
                    :items="signerList"
                    item-text="text"
                    item-value="id"
                    label=""
                    solo
                    return-object
                    >
                    <!-- Customize how each item appears in dropdown -->
                    <template v-slot:item="data">
                        <v-card class="pa-2" style="min-width: 400px;"> 
                            <v-row align="center" justify="space-between">
                                <v-col cols="8">
                                    <div v-if="lang == 1"><strong>{{ $t("res_Label_SignerName") }}             : </strong>{{ data.item.text.split('-')[0] }}</div> <!-- Name -->
                                    <div v-if="lang == 1"><strong>{{ $t("res_Label_SignerPosition") }}         : </strong>{{ data.item.text.split('-')[1] }}</div> <!-- Position -->
                                    <div v-if="lang != 1"><strong>{{ $t("res_Label_SignerName") }}             : </strong>{{ data.item.text.split('-')[0] }}</div> <!-- Name -->
                                    <div v-if="lang != 1"><strong>{{ $t("res_Label_SignerPosition") }}         : </strong>{{ data.item.text.split('-')[1] }}</div> <!-- Position -->
                                    <div><strong>{{ $t("res_GridHeaders_DefaultSignature") }} : </strong><span :style="{ color: data.item.isDefault ? 'green' : 'black' }">
                                                                                                                {{  lang == 1? data.item.isDefault: (data.item.isDefault ? 'نعم':'لا' ) }}
                                                                                                         </span></div> <!-- Default -->
                                </v-col>
                                <v-col cols="4" class="text-right">
                                    <v-img max-width="150" max-height="100" :src="'data:image/png;base64,'+ data.item.image"></v-img>
                                </v-col>
                            </v-row>
                        </v-card>
                    </template>

                    <template v-slot:selection="data">
                        <v-row no-gutters align="center" style="width: 100%;">
                        <v-col cols="2">
                            <v-img
                            max-width="80"
                            max-height="80  "
                            :src="'data:image/png;base64,' + data.item.image"
                            ></v-img>
                        </v-col>
                        <v-col>
                            {{  data.item.text }}
                        </v-col>
                        </v-row>
                    </template>

                </v-select>
            </div>
        </div>
        <div style="padding-top: 15px;">
            <v-card-actions class="gap-2 sticky-actions">
                <v-spacer></v-spacer>
                <v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelDialog">{{$t("res_ButtonText_Cancel")}}</v-btn>
                <v-btn class="primary" style="min-width: 100px !important;" :disabled="!validForm || (enableUserMultipleSignatures == true && (userSignatures == null || userSignatures.length <= 0))" @click="signDocument">{{$t("res_ButtonText_Continue")}}</v-btn>
            </v-card-actions>
        </div>
    </div>
</template>

<script>
    import constants from '@/assets/js/constants'
    import axios from 'axios'
    import CryptoJS from 'crypto-js';

	export default {
		name: 'Sign',
		data() {
            return {
                enableUserMultipleSignatures: constants.enableUserMultipleSignatures, 
                userSignature: null,
                userSignatures: [{id:0 , text: ''}],
                pinValue: '',
                onBehalfOf: false,
                validForm: false,
                //canSignByImpersonation:false,
                constants:constants,
                selectedSigner: {id:0 , text: ''},
                signerList: [],
                showSignaturesList:false,
                enableUserToSelectSigner:false,
                lang: localStorage.getItem('lang') == 'en',
                showNew: false,
            };
        },
        props: {
            documentId: { type: [String, Number], required: false },
            transferId: { type: [String, Number], required: false },
            delegationId: { type: Number, default: 0 },
            dialogModelShow: { type: Boolean, default: false },
            propertyBag: { type: Object },
            isSignAndSend: {type: Boolean, default: false},
            canSignWithoutPinCode: {type: Boolean, default: false},
            enableRecipientsMultiPages: {type: String, default: ""},
            purpose:  {type: Object},
            onBehalfOfChecked: {type: Boolean, default: false},
            isDelegatedDocumentSignProp: { type: Boolean, required: false, default: false }
        },
        methods:
        {
            resolvedDelegationId()
            {
                return this.propertyBag?.delegationId ?? this.delegationId ?? 0
            },
            async GetUserSignatures(documentId) {
                try { 
                        const response =
                            await axios.get(`${constants.baseApiUrl}Admin/GetUserSignaturesForSign?lang=${localStorage.getItem('lang')}&documentId=${documentId}`);
                        if (response.data) {  
                                this.userSignatures = response.data;
                                if(this.userSignatures.length == 1)
                                { this.userSignature = this.userSignatures[0]; }
                        }
                    }
                catch (error) 
                    {
                        console.error(error);
                    }
		    },
            getPermissionToSign()
            {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'Document/CheckHasValidSignature?delegationId=' + this.resolvedDelegationId())
                    .then(res =>
                    {
                        if (res.data == 'SignaturePinNotSet')
                            window.showAlert('res_Msgs_PinNotSet', 'warning')

                        else if (res.data == 'NoDefaultSignatureFound')
                            window.showAlert('res_Msgs_NoDefaultSignature', 'warning')
                        
                        else
                            this.validForm = true
                    })
                    .catch(err => window.showAlert(err, 'error'))
                    .finally(() => window.hideLoading())
            },
            async GetUserMultiSignatures(documentId) { 
                try {
                        const response =
                            await axios.get(`${constants.baseApiUrl}Admin/GetUserMultiSignaturesForSign?lang=${localStorage.getItem('lang')}&documentId=${documentId}`);
                        if (response.data) 
                        { 
                            if( response.data.count > 1 )
                            {
                                this.signerList = response.data.items;
                                if(this.signerList.length == 1)
                                { 
                                    this.signerList = this.signerList[0];
                                }
                                else
                                {
                                    this.selectedSigner = this.signerList.find(x => x.isDefault == true);
                                }

                                this.showSignaturesList = true;  
                            }
                            else 
                                this.showSignaturesList = false;
                        }
                    }
                catch (error) 
                    {
                        console.error(error);
                    }
		    },
           
        //    async getUserApplicatinRole() 
        //    {
        //         try 
        //         {
        //                 const response = await axios.get(constants.baseApiUrl + 'User/GetUserApplicationRole');
        //                 const data = response.data;
        //                 if (data && data.id == "5") {
        //                     this.enableUserToSelectSigner = true;
        //                     this.GetUserMultiSignatures(this.propertyBag.documentId);
        //                 } else {
        //                     this.enableUserToSelectSigner = false;
        //                 }   
        //         }    
        //         catch (err) {
        //                 console.error('Error fetching user role:', err);
        //         }
        //     },

            signDocument()
            {
                if (!this.canSignWithoutPinCode && this.pinValue == '' && !this.isSignAndSend)
                {
                    window.showAlert('res_Msgs_EnterPin', 'warning')
                }
                if (this.enableUserToSelectSigner && this.showSignaturesList && this.selectedSigner.id==0)
                {
                    window.showAlert('res_Msgs_SelectSignature', 'warning')
                }
                else
                {
                    window.showLoading()

                    if(this.isSignAndSend)
                        this.SignDocument()
                    else
                        this.CheckPinCodeAndSignDocument()
                }
            },
            CheckPinCodeAndSignDocument()
            {
                axios.get(constants.baseApiUrl + 'Document/CheckHasValidPin?pinValue=' + this.pinValue + '&canSignWithoutPinCode=' + this.canSignWithoutPinCode)
                        .then(res =>
                        {
                            if (res.data.item1 == false)
                            {
                                window.hideLoading()
                                if (res.data.item2 == 'SignaturePinNotSet')
                                {
                                    window.showAlert('res_Msgs_PinNotSet', 'warning')
                                }
                                else
                                    window.showAlert('res_Msgs_InvalidPin', 'error')
                            }
                            else
                            { 
                                 axios.get(constants.baseApiUrl + 'Document/CheckHasValidSignature?delegationId=' + this.resolvedDelegationId())
                                    .then(res =>
                                    { 
                                        if (res.data.item1 == false)
                                        {
                                            window.hideLoading()
                                             window.showAlert('res_Msgs_NoDefaultSignature', 'warning')
                                        }
                                        else            
                                        {
                                            const selectedSignerId = this.selectedSigner?.id ?? null;
                                            const enableRecipientsMultiPages = this.constants.enableRecipientsMultiPages && (this.enableRecipientsMultiPages == 1 || this.enableRecipientsMultiPages == '1' || constants.client_version_Id == "DEG") 
                                            const impersonatedSignature = this.isSignAndSend == true ? !this.onBehalfOfChecked : !this.onBehalfOf;

                                            axios.post(constants.baseApiUrl + 'Document/SignDocument?documentId=' + this.propertyBag.documentId + '&transferId=' + this.propertyBag.transferId + '&delegationId=' + this.resolvedDelegationId() + 
                                                '&impersonatedSignature=' + impersonatedSignature + 
                                                '&enableRecipientsMultiPages=' + enableRecipientsMultiPages + '&documentHashValue=' + this.propertyBag.documentHashValue  +'&selectedSignerId=' + selectedSignerId)
                                                .then(res =>
                                                {
                                                    if (res.data.status == false)
                                                    {
                                                        if (res.data.message == 'InvalidDocumentHashValue')
                                                        {
                                                            window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Msgs_DocumentChangedSinceSent'),
                                                                () => { this.$emit('refreshAfterClosingSignDialog') });
                                                        }
                                                        else if (res.data.message == 'MissingUserSignature') {
                                                            window.showAlert(this.$t('res_Msgs_MissingDefaultSignature'), 'warning');
                                                        }
                                                        else
                                                            window.showAlert(this.$t('res_Msgs_SignedFailed'), 'error')
                                                    }
                                                    else
                                                    {
                                                        window.showAlert(this.$t('res_Msgs_SignedSuccess'), 'success')
                                                        this.GetUserSignatures(this.propertyBag.documentId);
                                                        if (this.isSignAndSend)
                                                        {
                                                            window.showLoading()
                                                            this.$emit('uaeDocumentSigned')
                                                        }
                                                        else
                                                          this.$emit('refreshAfterClosingSignDialog')
                                                    }
                                                })
                                                .catch(error => console.log(error))
                                                .finally(() => window.hideLoading())
                                        }
                                    })
                                }
                        })
                        .catch(error => 
                        {
                            console.log(error); 
                            window.hideLoading(); 
                        })
            },
            SignDocument()
            {
                const enableRecipientsMultiPages = this.constants.enableRecipientsMultiPages && (this.enableRecipientsMultiPages == 1 || this.enableRecipientsMultiPages == '1' || constants.client_version_Id == "DEG") 
                
                const impersonatedSignature = this.isSignAndSend == true ? !this.onBehalfOfChecked : !this.onBehalfOf;
                axios.post(constants.baseApiUrl + 'Document/SignDocument?documentId=' + this.propertyBag.documentId + '&transferId=' + this.propertyBag.transferId 
                            + '&delegationId=' + this.resolvedDelegationId() + '&impersonatedSignature=' + impersonatedSignature + '&enableRecipientsMultiPages=' 
                            + enableRecipientsMultiPages + '&documentHashValue=' + this.propertyBag.documentHashValue  +'&selectedSignerId='
                            + (this.selectedSigner == null ? 0 : this.selectedSigner.id))
                        .then(res =>
                        {
                            if (res.data.status == false)
                            {
                                if (res.data.message == 'InvalidDocumentHashValue')
                                {
                                    window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Msgs_DocumentChangedSinceSent'),
                                        () => { this.$emit('refreshAfterClosingSignDialog')});
                                }
                                else if (res.data.message == 'MissingUserSignature') {
                                    window.showAlert(this.$t('res_Msgs_MissingDefaultSignature'), 'warning');
                                }
                                else
                                    window.showAlert(this.$t('res_Msgs_SignedFailed'), 'error')
                            }
                            else
                            {
                                window.showAlert(this.$t('res_Msgs_SignedSuccess'), 'success')
                                this.GetUserSignatures(this.propertyBag.documentId);
                                if (this.isSignAndSend)
                                { 
                                    window.showLoading()
                                    this.$emit('uaeDocumentSigned')
                                }
                                else
                                    this.$emit('refreshAfterClosingSignDialog')
                            }
                        })
                        .catch(error => console.log(error))
                        .finally(() => window.hideLoading())
            },
            // CheckSignatureImpersonation()
            // {
            //     axios.get(constants.baseApiUrl + 'Delegation/CanImpersonatedSign?delegationId=' + this.resolvedDelegationId())
            //         .then(res => 
            //         {
            //             this.canSignByImpersonation = res.data
            //             this.SelectedSignAsOption= this.canSignByImpersonation &&  constants.enableImpersonateSignatureInDelegation
                
            //         })
            //         .catch(err => console.log(err));
            // },
            cancelDialog()
            {
                this.onBehalfOf = this.isDelegatedDocumentSignProp == true ? true : false
                this.$emit('closeSignFormDialog');
            },
            resetForm()
            {
                this.pinValue = ''
                this.validForm = false
                //this.canSignByImpersonation = false
            },
            decryptParam(cipherText) 
            {
                var keeey = '3'+'e'+'3'+'5'+'e'+'e'+'a'+'4'+'7'+'1'+'7'+'7'+'5'+'1'+'9'+'1';
                var key = CryptoJS.enc.Utf8.parse(keeey);
                var iv = CryptoJS.enc.Utf8.parse(keeey);
            
                var decrypted = CryptoJS.AES.decrypt(cipherText, key, {
                keySize: 128 / 8,
                iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
                });
            
                return decrypted.toString(CryptoJS.enc.Utf8);
            }
        },
        watch:
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                    {
                        this.getPermissionToSign()
                        //this.CheckSignatureImpersonation()
                    }
                    else
                        this.resetForm()
                }
            },
            documentId:function(newValue,oldValue) {
                if (this.documentId > 0) {
                    this.GetUserSignatures(this.documentId); 
                }
            },
            isDelegatedDocumentSignProp(newVal, oldVal)
            {
                if (newVal == true)
                {
                    this.onBehalfOf = true
                }
                else
                {
                    this.onBehalfOf = false
                }
            },
        },
        mounted: function ()
        {
            if(sessionStorage.getItem("userPinCode") != undefined && sessionStorage.getItem("userPinCode") != "null")
            {
                this.pinValue = this.decryptParam(sessionStorage.getItem("userPinCode"));
            }

            this.onBehalfOf = this.isDelegatedDocumentSignProp == true ? true : false
            this.getPermissionToSign()
            //this.CheckSignatureImpersonation()
            this.GetUserSignatures(this.propertyBag.documentId );
            //this.getUserApplicatinRole();
            this.enableUserToSelectSigner = true;
            this.GetUserMultiSignatures(this.propertyBag.documentId);
        }
	}
</script>